import React from 'react'

export default function MyComponent () {
  return <div></div>
}



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/